<script setup lang="ts">
import { loginSchema, type LoginForm } from '#shared/utils/validation'

definePageMeta({ layout: 'default' })

useSeoMeta({ title: 'Entrar — Descontito', robots: 'noindex' })

const { user, login, loading } = useAuth()
const toast = useToast()

// Redireciona se já logado
if (user.value) await navigateTo('/')

const form = reactive<LoginForm>({ email: '', password: '' })

async function handleLogin() {
  const result = loginSchema.safeParse(form)
  if (!result.success) {
    toast.add({ title: 'Dados inválidos', description: result.error.errors[0]?.message, color: 'error' })
    return
  }
  try {
    await login(form)
    toast.add({ title: 'Bem-vindo de volta!', color: 'success' })
  }
  catch (err: unknown) {
    const message = (err as { data?: { message?: string } })?.data?.message ?? 'Credenciais inválidas'
    toast.add({ title: 'Erro ao entrar', description: message, color: 'error' })
  }
}
</script>

<template>
  <div class="max-w-md mx-auto py-8">
    <UCard>
      <template #header>
        <div class="text-center">
          <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Entrar no Descontito</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Não tem conta?
            <NuxtLink to="/registro" class="text-primary-500 hover:underline">Cadastre-se</NuxtLink>
          </p>
        </div>
      </template>

      <div class="space-y-4">
        <!-- Email / senha -->
        <UFormField label="E-mail" name="email">
          <UInput v-model="form.email" type="email" placeholder="seu@email.com" class="w-full" />
        </UFormField>

        <UFormField label="Senha" name="password">
          <UInput v-model="form.password" type="password" placeholder="••••••••" class="w-full" />
        </UFormField>

        <UButton
          color="primary"
          class="w-full"
          :loading="loading"
          @click="handleLogin"
        >
          Entrar
        </UButton>
      </div>
    </UCard>
  </div>
</template>
